import { uniqueByUUID } from '@/utils/uuidHelper';
import validateClauses, { cohortClauseParents } from '../clauses/helper';
import { findQueryClause, findQueryDictionary } from '../state/shared';

const validateCohortCountsInfo = (cohort, query, clause, withParents = false) => {
  const errors = [];
  const context = { entity: 'query', queryUUID: query.uuid, queryName: query.name };
  const dependents = cohort.settings.expose_cohort_counts
    ? validateClauses(query, [clause], errors, context, true, true)
    : [];

  return {
    dependents: errors.length === 0 ? dependents : [],
    parents: errors.length === 0 && withParents ? cohortClauseParents(query, clause) : [],
    exists: true,
  };
};

const validateCohortClauseCounts = (cohorts, {
  category,
  code,
  queryUUID,
  clauseUUID,
}) => {
  const { cohort, query, clause } = findQueryClause(cohorts, {
    category, code, queryUUID, clauseUUID,
  });

  return clause
    ? validateCohortCountsInfo(cohort, query, clause, true)
    : { dependents: [], parents: [], exists: false };
};

export const validateCohortClausesCounts = (cohorts, {
  category,
  code,
  queryUUID,
  dictionaryCode,
}, intl) => {
  const { cohort, query, clauses } = findQueryDictionary(cohorts, {
    category, code, queryUUID, dictionaryCode,
  });
  const dependents = clauses.filter((r) => (!r.isNew)).map(
    (c) => validateCohortCountsInfo(cohort, query, c, intl),
  ).map((d) => d.dependents);

  return dependents.some((d) => d.length === 0) ? [] : uniqueByUUID(dependents.flat());
};

export default validateCohortClauseCounts;
